<h2 mat-dialog-title class="dialog-title">Artikel bearbeiten</h2>
<mat-dialog-content class="mat-typography dialog-content">
  <!-- Loading indicator -->
  <div *ngIf="loading" class="loading-container">
    <p>Lade Daten...</p>
  </div>
  
  <form [formGroup]="frmArtikel" *ngIf="!loading">
    <!-- Nummer -->
    <div class="form-group">
      <label class="form-label" for="nummer">Nummer *</label>
      <input
        type="text"
        class="form-control"
        id="nummer"
        formControlName="nummer"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        placeholder="Nummer" />
    </div>

    <!-- Beschreibung -->
    <div class="form-group">
      <label class="form-label" for="beschreibung">Beschreibung *</label>
      <input
        type="text"
        class="form-control"
        id="beschreibung"
        formControlName="beschreibung"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        placeholder="Beschreibung" />
    </div>

    <!-- Beschreibung 2 -->
    <div class="form-group">
      <label class="form-label" for="beschreibung_2">Beschreibung 2</label>
      <input
        type="text"
        class="form-control"
        id="beschreibung_2"
        formControlName="beschreibung_2"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        placeholder="Beschreibung 2" />
    </div>

    <!-- Art -->
    <div class="form-group">
      <label class="form-label" for="art">Art</label>
      <select
        id="art"
        formControlName="art"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
        <option value="">Bitte wählen...</option>
        <option *ngFor="let art of artikelArten" [value]="art">{{ art }}</option>
      </select>
    </div>

    <!-- Basiseinheit -->
    <div class="form-group">
      <label class="form-label" for="basiseinheit">Basiseinheit</label>
      <select
        id="basiseinheit"
        formControlName="basiseinheit"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
        <option value="">Bitte wählen...</option>
        <option *ngFor="let basiseinheit of basiseinheiten" [value]="basiseinheit.code">{{ basiseinheit.beschreibung }} ({{ basiseinheit.code }})</option>
      </select>
    </div>

    <!-- Code -->
    <div class="form-group">
      <label class="form-label" for="code">Code</label>
      <input
        type="text"
        class="form-control"
        id="code"
        formControlName="code"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        placeholder="Code" />
    </div>

    <!-- Beschreibung Code -->
    <div class="form-group">
      <label class="form-label" for="beschreibung_code">Beschreibung Code</label>
      <input
        type="text"
        class="form-control"
        id="beschreibung_code"
        formControlName="beschreibung_code"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        placeholder="Beschreibung Code" />
    </div>

    <!-- In Code -->
    <div class="form-group">
      <label class="form-label" for="in_code">In Code</label>
      <input
        type="text"
        class="form-control"
        id="in_code"
        formControlName="in_code"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        placeholder="In Code" />
    </div>

    <!-- Alternative Beschreibung -->
    <div class="form-group">
      <label class="form-label" for="alternative_beschreibung">Alternative Beschreibung</label>
      <input
        type="text"
        class="form-control"
        id="alternative_beschreibung"
        formControlName="alternative_beschreibung"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        placeholder="Alternative Beschreibung" />
    </div>

    <!-- Belegtext -->
    <div class="form-group">
      <label class="form-label" for="belegtext">Belegtext</label>
      <textarea
        id="belegtext"
        formControlName="belegtext"
        rows="3"
        class="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        placeholder="Belegtext"></textarea>
    </div>

    <!-- Ausbringung -->
    <div class="form-group">
      <label class="form-label" for="ausbringung">Ausbringung</label>
      <select
        id="ausbringung"
        formControlName="ausbringung"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
        <option value="">Bitte wählen...</option>
        <option *ngFor="let ausbringung of ausbringungen" [value]="ausbringung.code">{{ ausbringung.beschreibung }} ({{ ausbringung.code }})</option>
      </select>
    </div>

    <!-- Sortierung -->
    <div class="form-group">
      <label class="form-label" for="sortierung">Sortierung</label>
      <input
        type="number"
        class="form-control"
        id="sortierung"
        formControlName="sortierung"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        placeholder="Sortierung" />
    </div>

    <!-- Zulassungen -->
    <div class="form-group">
      <label class="form-label" for="zulassungen">Zulassungen</label>
      <input
        type="text"
        class="form-control"
        id="zulassungen"
        formControlName="zulassungen"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        placeholder="Zulassungen" />
    </div>

    <!-- Sicherheitsdatenblatt -->
    <div class="form-group">
      <label class="form-label" for="sicherheitsdatenblatt">Sicherheitsdatenblatt</label>
      <input
        type="text"
        class="form-control"
        id="sicherheitsdatenblatt"
        formControlName="sicherheitsdatenblatt"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        placeholder="Sicherheitsdatenblatt" />
    </div>

    <!-- Systemkomponente -->
    <div class="form-group">
      <label class="form-label" for="systemkomponente">Systemkomponente</label>
      <input
        type="text"
        class="form-control"
        id="systemkomponente"
        formControlName="systemkomponente"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        placeholder="Systemkomponente" />
    </div>

    <!-- Zulassungs Nummer -->
    <div class="form-group">
      <label class="form-label" for="zulassungs_nummer">Zulassungs Nummer</label>
      <input
        type="text"
        class="form-control"
        id="zulassungs_nummer"
        formControlName="zulassungs_nummer"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        placeholder="Zulassungs Nummer" />
    </div>

    <!-- Wirkstoff -->
    <div class="form-group">
      <label class="form-label" for="wirkstoff">Wirkstoff</label>
      <input
        type="text"
        class="form-control"
        id="wirkstoff"
        formControlName="wirkstoff"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        placeholder="Wirkstoff" />
    </div>

    <!-- Status ID -->
    <div class="form-group">
      <label class="form-label" for="status_id">Status</label>
      <select
        id="status_id"
        formControlName="status_id"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
        <option value="">Bitte wählen...</option>
        <option *ngFor="let status of statusOptions" [value]="status.id">{{ status.beschreibung }} ({{ status.code }})</option>
      </select>
    </div>

    <!-- Biozid Produktart -->
    <div class="form-group">
      <label class="form-label" for="biozid_produktart">Biozid Produktart</label>
      <select
        id="biozid_produktart"
        formControlName="biozid_produktart"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
        <option value="">Bitte wählen...</option>
        <option *ngFor="let produktart of produktarten" [value]="produktart.id">{{ produktart.beschreibung }} ({{ produktart.code }})</option>
      </select>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Abbrechen</button>
  <button mat-button (click)="onConfirm()" cdkFocusInitial>Speichern</button>
</mat-dialog-actions> 
